import { HttpContextToken } from "@angular/common/http";

/** Set on a request whose caller shows its own error message, so the user is not toasted twice. */
export const SKIP_ERROR_TOAST = new HttpContextToken<boolean>(() => false);
